import defaultSettings from 'default-settings';


// This settings will set only for new widget installations
// old installations will use old settings
// IMPORTANT! Use it for overriding existed settings only
export default _.merge({}, defaultSettings, {
  numbers: {
    settingsVersion: 1,
  },
  booleans: {
    showChannelCategories: false,
  },
});



// WEBPACK FOOTER //
// ./src/default-settings/default-settings-v1.js